

export default class GoogleApi {


    static searchPlaces = (value: string)=>{

        const url = "https://places.googleapis.com/v1/places:autocomplete"

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Goog-Api-Key": gdConfig.googleApiKey
            },
            body: JSON.stringify({input: value})
        })
            .then((response: Response) => response.json())
            .catch((e: Error) => e);
    }

}
